<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원이용통계</span>
            <span class="txt">현재시간 기준으로 조회됩니다. (기간선택 불가)</span>
        </div>

        <p class="sub-title">
            이용 통계
            <small>월 단위 조회가 가능합니다.</small>
        </p>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="[...yearList]"
                    :select-value="[...yearValueList]"
                    :selected-value="yearDate"
                    class="w130"
                    @update:set="(val) => (yearDate = val)"
                ></select-form>
                <select-form
                    :select-data="[...monthList]"
                    :select-value="[...monthValueList]"
                    :selected-value="startDate"
                    class="w100"
                    @update:set="(val) => (startDate = val)"
                ></select-form>
            </div>
        </div>

        <div class="graph-content">
            <div class="graph-area">
                <div class="full">
                    <span class="title">
                        예약현황
                        <div class="com-tooltip">
                            <button class="icon"></button>
                            <div class="detail">
                                <p class="txt">
                                    예약 또는 취소 건 수에 대한 통계입니다.
                                    <br />
                                    관리자와 회원이 처리한 내역의 합계입니다.
                                </p>
                            </div>
                        </div>
                    </span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="chartOptions6" :series="series6" height="350" type="bar"></apexchart>
                    </div>
                </div>
            </div>
            <div class="graph-area">
                <div class="half">
                    <span class="title">
                        이용권별 사용횟수
                        <div class="com-tooltip">
                            <button class="icon"></button>
                            <div class="detail">
                                <p class="txt">
                                    출석/결석처리 완료여부와 상관 없이 예약한 시간이 지나면 사용처리 되어 사용횟수에
                                    포함됩니다.
                                </p>
                            </div>
                        </div>
                    </span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="chartOptions4" :series="series4" height="500" type="pie"></apexchart>
                    </div>
                </div>
                <div class="half">
                    <span class="title">입장현황</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="chartOptions5" :series="series5" height="500" type="pie"></apexchart>
                    </div>
                </div>
            </div>
        </div>

        <p class="sub-title">
            회원 통계
            <small>현재시간 기준으로 조회됩니다. (기간선택 불가)</small>
        </p>

        <div class="graph-content">
            <div class="graph-area">
                <div class="half">
                    <span class="title">성별 현황 - 유효회원</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <div id="chart">
                            <apexchart :options="chartOptions" :series="seriesB" height="500" type="pie"></apexchart>
                        </div>
                    </div>
                </div>
                <div class="half">
                    <span class="title">성별 현황 - 누적회원</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="chartOptions" :series="seriesTotal" height="500" type="pie"></apexchart>
                    </div>
                </div>
            </div>
            <div class="graph-area">
                <div class="half">
                    <span class="title">연령 비율 - 유효회원</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="chartOptions1" :series="series1" height="500" type="pie"></apexchart>
                    </div>
                </div>
                <div class="half">
                    <span class="title">연령 비율 - 누적회원</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="chartOptions1" :series="validCustomer" height="500" type="pie"></apexchart>
                    </div>
                </div>
            </div>
            <div class="graph-area">
                <div class="half">
                    <span class="title">유효 이용권 보유 현황</span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart :options="chartOptions2" :series="series2" height="500" type="pie"></apexchart>
                    </div>
                </div>
                <div class="half">
                    <span class="title">
                        등록비율
                        <div class="com-tooltip">
                            <button class="icon"></button>
                            <div class="detail">
                                <p class="txt">
                                    첫 신규등록 후 재등록을 했는지, 바로 종료가 되었는지 비율을 확인합니다.
                                    <br />
                                    자세한 설명은 하단 내용을 참고하세요.
                                </p>
                            </div>
                        </div>
                    </span>
                    <div class="graph-box" style="height: 500px">
                        <!-- 그래프 영역 -->
                        <apexchart
                            ref="realtimeChart"
                            :options="chartOptions3"
                            :series="series3"
                            height="500"
                            type="pie"
                        ></apexchart>
                        <div>재등록률:{{ reRate }}% 종료율:{{ endRate }}%</div>
                    </div>
                </div>
            </div>
            <ul class="notice-list">
                <li>
                    <span class="num">1</span>
                    현재 신규회원 : 조회 시점에서 유효한 이용권을 가진 신규회원 (현재 유효회원)
                </li>
                <li>
                    <span class="num">2</span>
                    2회 이상 재등록한 회원 : 조회 시점에서 이용권을 2회 이상 등록한 회원 (현재 유효외원 또는 종료회원일
                    수 있음)
                </li>
                <li>
                    <span class="num">3</span>
                    신규등록 후 바로 종료된 회원 : 조회 시점에서 1회 이용권 등록 후, 재등록을 하지 않은 종료회원 (현재
                    종료회원)
                    <br />
                    <span class="blue">1+2+3 의 합계는 전체 누적회원 입니다.</span>
                </li>
            </ul>
            <div class="notice-txt">
                재등록율 : 현재 신규회원(유효)을 제외한 누적회원 중 2회 이상 재등록한 회원을 보여줍니다. [ 재등록율 =
                <span class="n-2">2</span>
                / (
                <span class="n-2">2</span>
                +
                <span class="n-3">3</span>
                ) * 100 ]
                <br />
                종료율 : 조회 시점에서 유효한 이용권을 가진 신규회원 (현재 유효회원) [ 재등록율 =
                <span class="n-3">3</span>
                /(
                <span class="n-2">2</span>
                +
                <span class="n-3">3</span>
                ) * 100 ]
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'StatsSale',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        startDate: function (newValue) {
            this.startDate = newValue;
            console.log(this.startDate);
            this.init();
        },
        yearDate: function (newValue) {
            this.yearDate = newValue;
            console.log(this.yearDate);
            this.init();
        },
    },
    data() {
        return {
            centerId: '',
            monthList: [],
            monthValueList: [],
            startDate: moment().format('MM'),
            yearDate: moment().format('YYYY'),
            yearList: [],
            yearValueList: [],

            series: [],
            seriesTotal: [],
            validCustomer: [],
            seriesB: [0, 0],

            chartOptions: {
                chart: { width: 380, type: 'pie' },
                noData: { text: '데이터가 존재하지 않습니다.' },
                labels: ['남성', '여성'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 200 },
                            legend: { position: 'bottom' },
                        },
                    },
                ],
            }, //유효회원chartOption 끝
            series1: [],
            chartOptions1: {
                chart: { width: 380, type: 'pie' },
                noData: { text: '데이터가 존재하지 않습니다.' },
                labels: ['10대미만', '20대', '30대', '40대', '50대', '60대', '70대', '80대이상', '미입력'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 200 },
                            legend: { position: 'bottom' },
                        },
                    },
                ],
            }, //유효회원chartOption 끝
            series2: [],
            chartOptions2: {
                chart: { width: 380, type: 'pie' },
                noData: { text: '데이터가 존재하지 않습니다.' },
                labels: ['개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 200 },
                            legend: { position: 'bottom' },
                        },
                    },
                ],
            }, //유효이용권chartOption 끝
            series3: [],
            chartOptions3: {
                chart: { width: 380, type: 'pie' },
                noData: { text: '데이터가 존재하지 않습니다.' },
                labels: ['현재 신규회원', '2회이상 재등록한 회원', '신규등록 후 바로 종료된 회원'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 200 },
                            legend: { position: 'bottom' },
                        },
                    },
                ],
            }, //유효이용권chartOption 끝
            series4: [
                {
                    name: 'aa',
                    data: [],
                },
            ],
            chartOptions4: {
                chart: { width: 380, type: 'pie' },
                noData: { text: '데이터가 존재하지 않습니다.' },
                labels: ['개인', 'OT', '듀엣', '그룹', '쿠폰'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 200 },
                            legend: { position: 'bottom' },
                        },
                    },
                ],
            }, //이용권별 사용횟수 chartOption 끝
            series5: [],
            chartOptions5: {
                chart: { width: 380, type: 'pie' },
                noData: { text: '데이터가 존재하지 않습니다.' },
                labels: ['출석건수', '결석건수', '단순입장'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 200 },
                            legend: { position: 'bottom' },
                        },
                    },
                ],
            }, //입장현황 chartOption 끝
            series6: [
                {
                    name: '예약',
                    data: [],
                },
                {
                    name: '취소',
                    data: [],
                },
            ],
            chartOptions6: {
                chart: { width: 380, type: 'bar' },
                noData: { text: '데이터가 존재하지 않습니다.' },
                labels: ['개인', 'OT', '듀엣', '그룹', '쿠폰'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 100 },
                            legend: { position: 'bottom' },
                        },
                    },
                ],
            }, //입장현황 chartOption 끝
            reRate: 0,
            endRate: 0,
        }; //데이터 return 끝
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.init();
    },
    methods: {
        //초기화
        async init() {
            try {
                await this.onStatusReserve(); //예약현황
                await this.onStatusUseTicket(); //이용권별 사용횟수
                await this.onStatusAttend(); //입장현황
                await this.onStatusGender(); //성별 비율
                await this.onStatusAge(); //연령비율
                await this.onValidTicketStatus(); //유효이용권 조회
                await this.onRegRatio(); //등록비율 조회
                //년도 자동생성
                for (let i = 0; i < 6; i++) {
                    this.yearList.push(moment().subtract(i, 'y').format('YYYY년'));
                    this.yearValueList.push(moment().subtract(i, 'y').format('YYYY'));
                }
                //월 자동생성
                for (let j = 1; j < 13; j++) {
                    this.monthList.push(j + '월');
                    this.monthValueList.push(('00' + j).slice(-2));
                }
            } catch (error) {
                console.log(error);
                console.log('초기화에 실패하였습니다.');
            }
        },
        //예약현황 조회
        async onStatusReserve() {
            try {
                const { data } = await this.getStatusReserve();
                console.log('예약내역', data);
                let xaxis = [];
                let price_array = [0, 0, 0, 0, 0]; //예약
                let price_arrayC = [0, 0, 0, 0, 0]; //취소
                data.forEach((g) => {
                    if (xaxis.includes(g.ccp_buy_dt) != true) {
                        xaxis.push(g.ccp_buy_dt);
                    }
                    if (g.clsc_ticket_type_cd == 'P') {
                        price_array[0] = parseInt(g.clsc_resv_status_rr_cnt); //예약
                        price_arrayC[0] = parseInt(g.clsc_resv_status_rc_cnt); //취소
                    } else if (g.clsc_ticket_type_cd == 'O') {
                        price_array[1] = parseInt(g.clsc_resv_status_rr_cnt); //예약
                        price_arrayC[1] = parseInt(g.clsc_resv_status_rc_cnt); //취소
                    } else if (g.clsc_ticket_type_cd == 'D') {
                        price_array[2] = parseInt(g.clsc_resv_status_rr_cnt); //예약
                        price_arrayC[2] = parseInt(g.clsc_resv_status_rc_cnt); //취소
                    } else if (g.clsc_ticket_type_cd == 'G') {
                        price_array[3] = parseInt(g.clsc_resv_status_rr_cnt); //예약
                        price_arrayC[3] = parseInt(g.clsc_resv_status_rc_cnt); //취소
                    } else if (g.clsc_ticket_type_cd == 'C') {
                        price_array[4] = parseInt(g.clsc_resv_status_rr_cnt); //예약
                        price_arrayC[4] = parseInt(g.clsc_resv_status_rc_cnt); //취소
                    }
                });
                this.series6 = [
                    {
                        name: '예약',
                        data: price_array,
                    },
                    {
                        name: '취소',
                        data: price_arrayC,
                    },
                ];
            } catch (error) {
                console.log(error);
                console.log('예약목록조회');
            }
        },
        //예약현황 조회 API
        getStatusReserve() {
            return api.get(`/admin/api/center/${this.centerId}/stats/customer/use/ticket/reservation`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                },
            });
        },
        //이용권별 사용횟수 조회
        async onStatusUseTicket() {
            try {
                const { data } = await this.getStatusUseTicket();
                console.log('이용권별 사용횟수', data);
                let xaxis = [];
                let price_array = new Array(5).fill(0); //예약
                data.forEach((g) => {
                    if (xaxis.includes(g.ccp_buy_dt) != true) {
                        xaxis.push(g.ccp_buy_dt);
                    }
                    if (g.clsc_ticket_type_cd == 'P') {
                        price_array[0] = parseInt(g.clsc_atnd_status_cnt); //사용횟수
                    } else if (g.clsc_ticket_type_cd == 'O') {
                        price_array[1] = parseInt(g.clsc_atnd_status_cnt);
                    } else if (g.clsc_ticket_type_cd == 'D') {
                        price_array[2] = parseInt(g.clsc_atnd_status_cnt);
                    } else if (g.clsc_ticket_type_cd == 'G') {
                        price_array[3] = parseInt(g.clsc_atnd_status_cnt);
                    } else if (g.clsc_ticket_type_cd == 'C') {
                        price_array[4] = parseInt(g.clsc_atnd_status_cnt);
                    }
                });
                console.log('tra', price_array);
                this.series4 = price_array;
            } catch (error) {
                console.log(error);
                console.log('이용티켓사용횟수 오류가 있습니다.');
            }
        },
        //이용권별 사용횟수 조회 API
        getStatusUseTicket() {
            return api.get(`/admin/api/center/${this.centerId}/stats/customer/use/ticket/use-count`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                },
            });
        },

        //이용권별 입장현황 목록 조회
        async onStatusAttend() {
            try {
                const { data } = await this.getStatusAttend();
                console.log('이용권별 입장현황', data);
                let xaxis = [];
                let price_array = new Array(3).fill(0); //출석
                data.forEach((g) => {
                    // if(xaxis.includes(g.ccp_buy_dt) != true){
                    //     xaxis.push(g.ccp_buy_dt);
                    // }
                    if (g.clsc_atnd_status_cd == 'O') {
                        price_array[0] = parseInt(g.clsc_atnd_status_cnt); //사용횟수
                    } else if (g.clsc_atnd_status_cd == 'X') {
                        price_array[1] = parseInt(g.clsc_atnd_status_cnt);
                    } else if (g.clsc_atnd_status_cd == '-') {
                        price_array[2] = parseInt(g.clsc_atnd_status_cnt);
                    }
                });
                this.series5 = price_array;
                console.log('t', this.series5);
            } catch (error) {
                console.log(error);
                console.log('입장현황 목록 에러입니다.');
            }
        },
        //이용권별 입장현황 목록 조회 api
        getStatusAttend() {
            return api.get(`/admin/api/center/${this.centerId}/stats/customer/use/ticket/attendance`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                },
            });
        },

        //회원 성별현황 - 유효회원
        async onStatusGender() {
            try {
                const { data } = await this.getStatusGender();
                console.log('유효회원', data);
                let a = new Array(2).fill(0);
                let totalMember = new Array(2).fill(0);
                data.forEach((g) => {
                    // totalMember.push(parseInt(g.clsc_status_cnt));
                    // validMember.push(parseInt(g.clsc_valid_status_cnt));
                    if (g.cc_sex == 'M') {
                        totalMember[0] = parseInt(g.clsc_status_cnt);
                        a[0] = parseInt(g.clsc_valid_status_cnt);
                    } else if (g.cc_sex == 'W') {
                        totalMember[1] = parseInt(g.clsc_status_cnt);
                        a[1] = parseInt(g.clsc_valid_status_cnt);
                    }
                });
                this.seriesB = a;
                this.seriesTotal = totalMember;
                console.log('con', a);
            } catch (error) {
                console.log(error);
                console.log('성별현황 유효회원 오류입니다.');
            }
        },

        //성별현황 api
        getStatusGender() {
            return api.get(`/admin/api/center/${this.centerId}/stats/customer/use/customer-sex`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                },
            });
        },
        //회원 연령비율 현황
        async onStatusAge() {
            try {
                const { data } = await this.getStatusAge();
                console.log('연령비율 현황', data);

                let seriesArray = new Array(9).fill(0); //누적회원
                let seriesValidArray = new Array(9).fill(0); //유효회원
                data.forEach((g) => {
                    if (g.cc_age < 10) {
                        seriesArray[0] = parseInt(g.cc_status_cnt);
                        seriesValidArray[0] = parseInt(g.cc_valid_status_cnt);
                    } else if (g.cc_age < 20) {
                        seriesArray[1] = parseInt(g.cc_status_cnt);
                        seriesValidArray[1] = parseInt(g.cc_valid_status_cnt);
                    } else if (g.cc_age < 30) {
                        seriesArray[2] = parseInt(g.cc_status_cnt);
                        seriesValidArray[2] = parseInt(g.cc_valid_status_cnt);
                    } else if (g.cc_age < 40) {
                        seriesArray[3] = parseInt(g.cc_status_cnt);
                        seriesValidArray[3] = parseInt(g.cc_valid_status_cnt);
                    } else if (g.cc_age < 50) {
                        seriesArray[4] = parseInt(g.cc_status_cnt);
                        seriesValidArray[4] = parseInt(g.cc_valid_status_cnt);
                    } else if (g.cc_age < 60) {
                        seriesArray[5] = parseInt(g.cc_status_cnt);
                        seriesValidArray[5] = parseInt(g.cc_valid_status_cnt);
                    } else if (g.cc_age < 70) {
                        seriesArray[6] = parseInt(g.cc_status_cnt);
                        seriesValidArray[6] = parseInt(g.cc_valid_status_cnt);
                    } else if (g.cc_age < 80) {
                        seriesArray[7] = parseInt(g.cc_status_cnt);
                        seriesValidArray[7] = parseInt(g.cc_valid_status_cnt);
                    } else if ((g.cc_age = 0 || null)) {
                        seriesArray[8] = parseInt(g.cc_status_cnt);
                        seriesValidArray[8] = parseInt(g.cc_valid_status_cnt);
                    }
                });
                this.series1 = seriesArray;
                this.validCustomer = seriesValidArray;
                console.log('연령비율', this.series1);
            } catch (error) {
                console.log(error);
                console.log('연령비율 에러');
            }
        },
        //연령비율 API
        getStatusAge() {
            return api.get(`/admin/api/center/${this.centerId}/stats/customer/use/customer-age`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                },
            });
        },
        //유효 이용권 보유 현황 조회
        async onValidTicketStatus() {
            try {
                const { data } = await this.getValidTicketStatus();
                console.log('이용권조회', data);
                let validTicket = new Array(5).fill(0);
                data.forEach((g) => {
                    if (g.ccp_ticket_type_cd == 'P') {
                        validTicket[0] = parseInt(g.ccp_ticket_type_cnt); //이용권 보유 현황
                    } else if (g.ccp_ticket_type_cd == 'O') {
                        validTicket[1] = parseInt(g.ccp_ticket_type_cnt);
                    } else if (g.ccp_ticket_type_cd == 'D') {
                        validTicket[2] = parseInt(g.ccp_ticket_type_cnt);
                    } else if (g.ccp_ticket_type_cd == 'G') {
                        validTicket[3] = parseInt(g.ccp_ticket_type_cnt);
                    } else if (g.ccp_ticket_type_cd == 'C') {
                        validTicket[4] = parseInt(g.ccp_ticket_type_cnt);
                    }
                });
                this.series2 = validTicket;
                console.log('fhzldd', this.series2);
            } catch (error) {
                console.log(error);
                console.log('유효 이용권이 없습니다.');
            }
        },
        //유효 이용권 조회 api
        getValidTicketStatus() {
            return api.get(`/admin/api/center/${this.centerId}/stats/customer/use/valid-customer/ticket`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                },
            });
        },
        //등록비율 조회
        async onRegRatio() {
            try {
                const { data } = await this.getRegRatio();
                this.series3 = [
                    parseInt(data[0].cc_valid_status_cnt),
                    parseInt(data[2].cc_re_status_cnt),
                    parseInt(data[1].cc_end_status_cnt),
                ];
                //재등록률
                this.reRate = Math.round(
                    (parseInt(data[2].cc_re_status_cnt) /
                        (parseInt(data[2].cc_re_status_cnt) + parseInt(data[1].cc_end_status_cnt))) *
                        100
                );
                //종료율
                this.endRate = Math.round(
                    (parseInt(data[1].cc_end_status_cnt) /
                        (parseInt(data[2].cc_re_status_cnt) + parseInt(data[1].cc_end_status_cnt))) *
                        100
                );
                console.log('재등록률', this.reRate, '종료율', this.endRate);
                console.log(this.series3);
                console.log('등록비율 조회', data);
            } catch (error) {
                console.log(error);
                console.log('등록비율을 조회하는데 오류가 발생하였습니다.');
            }
        },
        //등록비율 조회 API
        getRegRatio() {
            return api.get(`/admin/api/center/${this.centerId}/stats/customer/use/reg/rate`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                },
            });
        },
    },
};
</script>
<style lang="scss"></style>
